<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <CRow>
                <CCol>
                    <h1 class="page__title">{{ $t(titlePage) }}</h1>
                </CCol>
                <CCol class="d-flex" md="1"> </CCol>
            </CRow>
            <!-- Title page  -->
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <!-- Filter -->
                <CRow class="justify-content-end p-2 mb-4">
                    <CCol md="6">
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
            </CContainer>
            <CContainer fluid>
                <CRow>
                    <CCol sm="12">
                        <CCard>
                            <CCardHeader>
                                <CCol md="1">
                                    <ButtonBack class="mr-3" title="Go back" />
                                </CCol>
                            </CCardHeader>
                            <CCardBody>
                                <CRow>
                                    <CCol xl="12" md="12">
                                        <CCard>
                                            <CCardHeader>
                                                <CContainer :fluid="true">
                                                    <CRow>
                                                        <CCol sm="11">
                                                            <h4>
                                                                {{
                                                                    $t("Optin")
                                                                }}
                                                            </h4>
                                                            <p class="mb-0">
                                                                {{
                                                                    $t(
                                                                        "You can view the validated leads per campaign"
                                                                    )
                                                                }}
                                                            </p>
                                                        </CCol>
                                                        <CCol sm="1"> </CCol>
                                                    </CRow>
                                                </CContainer>
                                            </CCardHeader>
                                            <CCardBody>
                                                <CContainer>
                                                    <CRow>
                                                        <CCol col="12" sm="6">
                                                            <CCallout
                                                                color="info"
                                                            >
                                                                <small
                                                                    class="text-muted"
                                                                    >{{
                                                                        $t(
                                                                            "Validated"
                                                                        )
                                                                    }}</small
                                                                ><br />
                                                                <strong
                                                                    class="h4"
                                                                    >{{
                                                                        this
                                                                            .callouts
                                                                            .validatedOptin.count
                                                                    }}</strong
                                                                >
                                                            </CCallout>
                                                        </CCol>
                                                        <CCol col="12" sm="6">
                                                            <CCallout
                                                                color="danger"
                                                            >
                                                                <small
                                                                    class="text-muted"
                                                                    >{{
                                                                        $t(
                                                                            "Percentage"
                                                                        )
                                                                    }}</small
                                                                ><br />
                                                                <strong
                                                                    class="h4"
                                                                    >{{
                                                                        this
                                                                            .callouts
                                                                            .percentageValidatedOptin.count
                                                                    }}%</strong
                                                                >
                                                            </CCallout>
                                                        </CCol>
                                                    </CRow>
                                                </CContainer>
                                            </CCardBody>
                                        </CCard>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol xl="12" md="12">
                                        <CCard>
                                            <CCardHeader>
                                                <CContainer :fluid="true">
                                                    <CRow>
                                                        <CCol sm="11">
                                                            <h4>
                                                                {{
                                                                    $t(
                                                                        "Phone cleaner"
                                                                    )
                                                                }}
                                                            </h4>
                                                            <p class="mb-0">
                                                                {{
                                                                    $t(
                                                                        "You can see the phones cleaned and validated by campaign"
                                                                    )
                                                                }}
                                                            </p>
                                                        </CCol>
                                                        <CCol sm="1"> </CCol>
                                                    </CRow>
                                                </CContainer>
                                            </CCardHeader>
                                            <CCardBody>
                                                <CContainer>
                                                    <CRow>
                                                        <CCol col="12" sm="6">
                                                            <CCallout
                                                                color="info"
                                                            >
                                                                <small
                                                                    class="text-muted"
                                                                    >{{
                                                                        $t(
                                                                            "Pre validated"
                                                                        )
                                                                    }}</small
                                                                ><br />
                                                                <strong
                                                                    class="h4"
                                                                    >{{
                                                                        callouts
                                                                            .phonesPreValidated
                                                                            .count
                                                                    }}</strong
                                                                >
                                                            </CCallout>
                                                        </CCol>
                                                        <CCol col="12" sm="6">
                                                            <CCallout
                                                                color="danger"
                                                            >
                                                                <small
                                                                    class="text-muted"
                                                                    >{{
                                                                        $t(
                                                                            "Validated"
                                                                        )
                                                                    }}</small
                                                                ><br />
                                                                <strong
                                                                    class="h4"
                                                                    >{{
                                                                        callouts
                                                                            .phonesValidated
                                                                            .count
                                                                    }}</strong
                                                                >
                                                            </CCallout>
                                                        </CCol>
                                                    </CRow>
                                                </CContainer>
                                            </CCardBody>
                                        </CCard>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol xl="12" md="12">
                                        <CCard>
                                            <CCardHeader>
                                                <CContainer :fluid="true">
                                                    <CRow>
                                                        <CCol sm="11">
                                                            <h4>
                                                                {{
                                                                    $t(
                                                                        "Breakdown by provider"
                                                                    )
                                                                }}
                                                            </h4>
                                                            <p class="mb-0">
                                                                {{
                                                                    $t(
                                                                        "The table below shows the number of records by each provider. Origins that do not have an associated provider are not counted"
                                                                    )
                                                                }}
                                                            </p>
                                                        </CCol>
                                                        <CCol sm="1">
                                                            <TableSettings
                                                                :allFields="
                                                                    tables
                                                                        .providers
                                                                        .allFields
                                                                "
                                                                :activeFields.sync="
                                                                    tables
                                                                        .providers
                                                                        .fields
                                                                "
                                                            />
                                                        </CCol>
                                                    </CRow>
                                                </CContainer>
                                            </CCardHeader>
                                            <CCardBody>
                                                <CDataTable
                                                    :addTableClasses="[
                                                        'table--sm',
                                                    ]"
                                                    :items="
                                                        tables.providers.items
                                                    "
                                                    :fields="
                                                        traslateArrayObjects({
                                                            array: tables
                                                                .providers
                                                                .fields,
                                                            fields: ['label'],
                                                        })
                                                    "
                                                    @update:column-filter-value="
                                                        updateData()
                                                    "
                                                    @update:sorter-value="
                                                        updateData()
                                                    "
                                                    :columnFilterValue.sync="
                                                        tables.providers
                                                            .columnFilterValue
                                                    "
                                                    :items-per-page="
                                                        tables.providers.rows
                                                    "
                                                    v-bind="tables.providers"
                                                >
                                                    <template #over-table>
                                                        <CContainer
                                                            :fluid="true"
                                                        >
                                                            <CRow
                                                                class="p-2 m-0"
                                                            >
                                                                <CCol
                                                                    md="12"
                                                                    sm="12"
                                                                >
                                                                    <!-- Filter -->
                                                                    <FilterFields
                                                                        :fields="
                                                                            tables
                                                                                .providers
                                                                                .fields
                                                                        "
                                                                        @filter="
                                                                            updateData
                                                                        "
                                                                    />
                                                                </CCol>
                                                            </CRow>
                                                        </CContainer>
                                                    </template>
                                                    <template #id="{ index }">
                                                        <td>{{ index + 1 }}</td>
                                                    </template>
                                                    <template #footer>
                                                        <tfoot>
                                                            <tr>
                                                                <td
                                                                    v-for="item in tables
                                                                        .providers
                                                                        .fields"
                                                                    :key="
                                                                        item.key
                                                                    "
                                                                >
                                                                    <span
                                                                        v-if="
                                                                            item.key ===
                                                                            'name'
                                                                        "
                                                                    >
                                                                        {{
                                                                            $t(
                                                                                "total"
                                                                            )
                                                                        }}
                                                                    </span>
                                                                    <span
                                                                        v-else-if="
                                                                            item.key !==
                                                                                'id' &&
                                                                            item.key !==
                                                                                'input'
                                                                        "
                                                                    >
                                                                        {{
                                                                            countTotal(
                                                                                tables
                                                                                    .providers
                                                                                    .itemsFiltered,
                                                                                [
                                                                                    item.key,
                                                                                ]
                                                                            )[
                                                                                item
                                                                                    .key
                                                                            ]
                                                                        }}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </tfoot>
                                                    </template>
                                                    <template #under-table>
                                                        <div
                                                            class="d-flex justify-content-end"
                                                        >
                                                            <ButtonExport
                                                                :endPoint="
                                                                    '/campaigns.api/inputs/' +
                                                                    uuid +
                                                                    '/providers/stats'
                                                                "
                                                                :table="
                                                                    tables.providers
                                                                "
                                                            />
                                                        </div>
                                                    </template>
                                                </CDataTable>
                                            </CCardBody>
                                        </CCard>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol xl="12" md="12">
                                        <CCard>
                                            <CCardHeader>
                                                <CContainer :fluid="true">
                                                    <CRow>
                                                        <CCol sm="11">
                                                            <h4>
                                                                {{
                                                                    $t(
                                                                        "Breakdown by origin"
                                                                    )
                                                                }}
                                                            </h4>
                                                            <p class="mb-0">
                                                                {{
                                                                    $t(
                                                                        "The table below shows the number of records by each origin"
                                                                    )
                                                                }}
                                                            </p>
                                                        </CCol>
                                                        <CCol sm="1">
                                                            <TableSettings
                                                                :allFields="
                                                                    tables
                                                                        .origins
                                                                        .allFields
                                                                "
                                                                :activeFields.sync="
                                                                    tables
                                                                        .origins
                                                                        .fields
                                                                "
                                                            />
                                                        </CCol>
                                                    </CRow>
                                                </CContainer>
                                            </CCardHeader>
                                            <CCardBody>
                                                <CDataTable
                                                    :addTableClasses="[
                                                        'table--sm',
                                                    ]"
                                                    :items="
                                                        tables.origins.items
                                                    "
                                                    :fields="
                                                        traslateArrayObjects({
                                                            array: tables
                                                                .origins.fields,
                                                            fields: ['label'],
                                                        })
                                                    "
                                                    @update:column-filter-value="
                                                        updateData()
                                                    "
                                                    @update:sorter-value="
                                                        updateData()
                                                    "
                                                    :columnFilterValue.sync="
                                                        tables.origins
                                                            .columnFilterValue
                                                    "
                                                    :items-per-page="
                                                        tables.origins.rows
                                                    "
                                                    v-bind="tables.origins"
                                                >
                                                    <template #id="{ index }">
                                                        <td>{{ index + 1 }}</td>
                                                    </template>
                                                    <template #over-table>
                                                        <CContainer
                                                            :fluid="true"
                                                        >
                                                            <CRow
                                                                class="p-2 m-0"
                                                            >
                                                                <CCol
                                                                    md="12"
                                                                    sm="12"
                                                                >
                                                                    <!-- Filter -->
                                                                    <FilterFields
                                                                        :fields="
                                                                            tables
                                                                                .origins
                                                                                .fields
                                                                        "
                                                                        @filter="
                                                                            updateData
                                                                        "
                                                                    />
                                                                </CCol>
                                                            </CRow>
                                                        </CContainer>
                                                    </template>
                                                    <template #footer>
                                                        <tfoot>
                                                            <tr>
                                                                <td
                                                                    v-for="item in tables
                                                                        .origins
                                                                        .fields"
                                                                    :key="
                                                                        item.key
                                                                    "
                                                                >
                                                                    <span
                                                                        v-if="
                                                                            item.key ===
                                                                            'origin'
                                                                        "
                                                                    >
                                                                        {{
                                                                            $t(
                                                                                "total"
                                                                            )
                                                                        }}
                                                                    </span>
                                                                    <span
                                                                        v-else-if="
                                                                            item.key !==
                                                                                'id' &&
                                                                            item.key !==
                                                                                'input' &&
                                                                            item.key !==
                                                                                'name'
                                                                        "
                                                                    >
                                                                        {{
                                                                            countTotal(
                                                                                tables
                                                                                    .origins
                                                                                    .itemsFiltered,
                                                                                [
                                                                                    item.key,
                                                                                ]
                                                                            )[
                                                                                item
                                                                                    .key
                                                                            ]
                                                                        }}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </tfoot>
                                                    </template>
                                                    <template #under-table>
                                                        <div
                                                            class="d-flex justify-content-end"
                                                        >
                                                            <ButtonExport
                                                                :endPoint="
                                                                    '/campaigns.api/inputs' +
                                                                    uuid +
                                                                    '/origins/stats'
                                                                "
                                                                :table="
                                                                    tables.origins
                                                                "
                                                            />
                                                        </div>
                                                    </template>
                                                </CDataTable>
                                            </CCardBody>
                                        </CCard>
                                    </CCol>
                                </CRow>
                            </CCardBody>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import FilterDate from "~/components/FilterDate";
import ChartGauge from "£lement/ChartGauge";
import ButtonBack from "£lement/ButtonBack";
import TableSettings from "£lement/TableSettings";
import ButtonExport from "~/components/ButtonExport";
import FilterFields from "~/components/FilterFields";
/** Mixins */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";

import { mapGetters } from "vuex";

/** Others */
import {
    cilWarning,
    cilPlus,
    cilDataTransferDown,
    cilSettings,
    cilEnvelopeClosed,
} from "@coreui/icons";

export default {
    name: "InputCampaignDetails",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        FilterDate,
        ChartGauge,
        ButtonBack,
        ButtonExport,
        TableSettings,
        FilterFields,
    },
    icons: {
        cilWarning,
        cilPlus,
        cilDataTransferDown,
        cilSettings,
        cilEnvelopeClosed,
    },
    data() {
        return {
            callouts: {
                phonesPreValidated: {
                    count: 0,
                },
                phonesValidated: {
                    count: 0,
                },
                validatedOptin: {
                    count: 0,
                },
                percentageValidatedOptin: {
                    count: 0,
                },
            },
            tables: {
                providers: {
                    fields: [
                        {
                            key: "id",
                            label: "#",
                            fixed: true,
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "name",
                            label: "name",
                            _filter: true,
                            filter: true,
                        },
                        {
                            key: "total",
                            label: "total",
                            _style: "width:15%",
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "count",
                            label: "count",
                            _style: "width:15%",
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "duplicate",
                            label: "duplicate",
                            _style: "width:15%",
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "deduplicate",
                            label: "deduplicate",
                            _style: "width:15%",
                            filter: false,
                            _filter: false,
                        },
                    ],
                    items: [],
                    itemsFiltered: [],
                    order: "asc",
                    loading: true,
                    hover: true,
                    size: "sm",
                    responsive: true,
                    itemsFiltered: [],
                    allFields: [],
                    tableFilterValue: undefined,
                    sorter: {
                        external: true,
                        resetable: true,
                    },
                    columnFilter: {
                        external: true,
                        lazy: true,
                    },
                    columnFilterValue: {},
                    dateFieldFilter: "date",
                },
                origins: {
                    fields: [
                        {
                            key: "id",
                            label: "#",
                            fixed: true,
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "origin",
                            label: "origin",
                            filter: true,
                            _filter: true,
                        },
                        {
                            key: "name",
                            label: "provider",
                            filter: true,
                            _filter: true,
                        },
                        {
                            key: "total",
                            label: "total",
                            _style: "width:15%",
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "count",
                            label: "count",
                            _style: "width:15%",
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "duplicate",
                            label: "duplicate",
                            _style: "width:15%",
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "deduplicate",
                            label: "deduplicate",
                            _style: "width:15%",
                            filter: false,
                            _filter: false,
                        },
                    ],
                    items: [],
                    itemsFiltered: [],
                    order: "asc",
                    loading: true,
                    hover: true,
                    size: "sm",
                    responsive: true,
                    itemsFiltered: [],
                    allFields: [],
                    tableFilterValue: undefined,
                    sorter: true,
                    sorter: {
                        external: true,
                        resetable: true,
                    },
                    columnFilter: {
                        external: true,
                        lazy: true,
                    },
                    columnFilterValue: {},
                    dateFieldFilter: "date",
                },
            },
        };
    },
    computed: {
        ...mapGetters({
            from: "filter/from",
            to: "filter/to",
        }),
        uuid: function () {
            return this.$route.params.uuid;
        },
    },
    methods: {
        countTotal(items, fields = []) {
            let total = {};
            for (let i = 0; i < fields.length; i++) {
                const field = fields[i];
                total = {
                    ...total,
                    [field]: items.reduce(
                        (total, item) => total + parseInt(item[field]),
                        0
                    ),
                };
            }
            return total;
        },

        async updateData() {
            await this.updateTable({
                tableName: "providers",
                url: `/campaigns.api/inputs/${this.uuid}/providers/stats`,
            });
            await this.updateTable({
                tableName: "origins",
                url: `/campaigns.api/inputs/${this.uuid}/origins/stats`,
            });

            // Desactivamos las estadisticas hasta optimizar el tiempo de carga.
            /**
            let data = await this.fetcher({
                url: `/automatic.validator.api/phones/validation/statistics/by/provider/${this.uuid}`,
            });

            this.callouts.phonesPreValidated.count = data.data.preValidated;
            this.callouts.phonesValidated.count = data.data.validated;

            let resp = await this.fetcher({
                baseURL: process.env.VUE_APP_API_SASS,
                url: "/optin/stats/" + this.uuid,
                method: "POST",
                data: {
                    dateStart: this.from,
                    dateEnd: this.to,
                },
            });

            let totalLeads = resp.totalLeads ? parseInt(resp.totalLeads) : 0;
            this.callouts.validatedOptin.count = resp.validatedLeads
                ? parseInt(resp.validatedLeads)
                : 0;
            this.callouts.percentageValidatedOptin.count =
                totalLeads > 0
                    ? Math.round(
                          (this.callouts.validatedOptin / totalLeads) * 100
                      )
                    : 0;
             */
            this.updatePageLoading(false);
        },
    },
    async mounted() {
        await this.updateData();
    },
};
</script>

<style scoped lang="scss"></style>
